// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

export enum IntellicheckUploadStep {
    Begin = 1,
    Capture = 2,
    Preview = 3,
    Fallback = 4,
}
